var map = {
	"./Agregators.svg": 6095,
	"./Chatbots.svg": 8474,
	"./Content_Apps.svg": 118,
	"./Graphic_design.svg": 1447,
	"./Landing_page.svg": 8240,
	"./Online_Store.svg": 4379,
	"./Promo_Apps.svg": 657,
	"./Social_media.svg": 7371,
	"./UI_UX_design.svg": 7502,
	"./Web_design.svg": 2366,
	"./cart_back_1.svg": 7252,
	"./cart_back_2.svg": 8792,
	"./cart_back_3.svg": 334,
	"./cart_under_1.svg": 7228,
	"./head_1.svg": 2992,
	"./head_2.svg": 1311,
	"./head_3.svg": 3634,
	"./head_4.svg": 1302,
	"./head_5.svg": 7899,
	"./head_6.svg": 921,
	"./img_1.svg": 3772,
	"./inst.svg": 4449,
	"./jquery-icon_.svg": 1158,
	"./line.svg": 7063,
	"./tg.svg": 9615,
	"./vk.svg": 9148,
	"./vue-js-icon_.svg": 4686,
	"./yii-php-framework-icon_.svg": 2426,
	"./yii.svg": 8544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;